


























































































import { AuthService } from "@/services/auth.service";
import { AuthModule } from "@/store/auth.module";
import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import GlobalMixin from "@/mixins/GlobalMixin";

@Component({})
export default class UpdatePassword extends Mixins(FormValidator, GlobalMixin) {
  formRef = "updatePasswordForm";
  isSecretHashActive: boolean = false;
  message: string = "";
  showPassword: boolean = false;
  password: string = "";
  passwordRepeated: string = "";
  innerMessage: string = "";
  secretHash: string;
  loading: boolean = false;

  async created() {
    const { query } = this.$route;
    if (!query.secret) {
      return this.$router.push("/");
    }
    if (AuthModule.user) AuthService.logout();
  }
  async savePasswordY() {
    if (!this.validateForm()) return;
    try {
      this.loading = true;
      this.innerMessage = null as any;
      const result = await AuthModule.updatePassword({
        secretHash: this.secretHash,
        password: this.password,
      });

      switch (result) {
        case "NewPasswordSuccessfullySet":
          this.$router.push({ name: "passChanged" });
          break;
        case "LinkLifetimeExpired":
          this.isSecretHashActive = false;
          this.message = this.$t("form-validator.link_expired2") as string;
          break;
        case "InvalidPassword":
          this.innerMessage = "form-validator.pass";
          break;
        case "NewPasswordEqualToOldPassword":
          this.innerMessage =
            "Новый пароль должен отличаться не менее чем на один символ";
          break;

        default:
          break;
      }
    } finally {
      this.loading = false;
    }
  }

  passwordConfirmationRule() {
    return (
      this.password === this.passwordRepeated ||
      this.$t("form-validator.pass_rep_incorr")
    );
  }

  async mounted() {
    this.secretHash = this.$route.query.secret as string;
    const response = await AuthModule.isSercretHashExists(this.secretHash);
    if (response.isExists && !response.isSecretHashValid) {
      this.isSecretHashActive = false;
      this.message = "form-validator.link_expired";
      return;
    }
    this.isSecretHashActive = response.isExists;
    this.message = "form-validator.link_expired2";
  }

  public async clickBack() {
    this.$router.push({ name: "auth" });
  }
}
